// src/helper/getFormatYmToLongTitle.js

/*
 * Перетворює 'YYYY-MM' → 'November 2025'
 * @param {string} ym - Рядок у форматі 'YYYY-MM'
 * @param {string} [locale='en'] - Локаль для назви місяця
 * @returns {string}
 */
export default function getFormatYmToLongTitle(ym, locale = 'en') {
	const [ y, m ] = ym.split('-').map(Number); // не парсимо '2025-11' напряму (Safari!)
	const d = new Date(Date.UTC(y, m - 1, 1)); // 1-ше число місяця
	return new Intl.DateTimeFormat(locale, { month: 'long', year: 'numeric' }).format(d);
}
